import { Component, Inject, OnInit } from '@angular/core';
import { PrintGSTReportComponent } from '../print-gstreport/print-gstreport.component';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { formatDate } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-view-vatnaval',
  // standalone: true,
  // imports: [],
  templateUrl: './view-vatnaval.component.html',
  styleUrl: './view-vatnaval.component.scss'
})
export class ViewVatnavalComponent implements OnInit {




  startDate = '';
  endDate = '';
  sundayDates: string[] = [];
  today: any;

  VatnavalViewData: any[] = [];
  month: any;
  year: any;
  monthName: any;
  total_records: any;


  constructor(
    private dialogref: MatDialogRef<PrintGSTReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) {
    this.today = formatDate(new Date(), 'yyyy/MM/dd', 'en-IN', 'GMT+0530');
  }

  ngOnInit(): void {

    this.startDate = this.data.start;
    this.month = this.data.month;
    this.year = this.data.year;
    this.monthName = this.data.monthName;
    this.total_records = this.data.total_records;

    this.endDate = this.data.end;

  
    console.log("Start:", this.startDate);
    console.log("month:", this.month);
    console.log("year:", this.year);

     // ✅ Get all Sundays
    this.sundayDates = this.getSundaysOfMonth(this.month, this.year);

    console.log("Sunday Dates:", this.sundayDates);
   


  // ✅ Call API
  this.getVatnavalViewDataByMonthYear(this.month, this.year);

  }


getVatnavalViewDataByMonthYear(month: any, year: any) {

  this.service.getVatnavalDataByMonthYear(month, year).subscribe((res: any) => {

    if (res && res.length > 0) {

      // ✅ NO FILTER (IMPORTANT)
      let filteredData = res;

      this.VatnavalViewData = filteredData.map((item: any) => {

        const sundayMap: any = {};

        this.sundayDates.forEach((sunday: string, index: number) => {

          const weekIndex = index + 1;

          const apiDate = item[`issue_Date_Week${weekIndex}`];
          const count = Number(item[`week${weekIndex}_count`]) || 0;

          if (apiDate) {
            const formattedDate = formatDate(apiDate, 'dd/MM/yyyy', 'en-IN');
            sundayMap[formattedDate] = count;
          }

          // ✅ VERY IMPORTANT (ensure all Sundays exist)
          if (!sundayMap[sunday]) {
            sundayMap[sunday] = 0;
          }

        });

        return {
          ...item,
          ...sundayMap
        };
      });

      // ✅ SORT
      this.VatnavalViewData.sort((a, b) => {
        return (a.place || '').localeCompare(b.place || '', 'mr');
      });

      console.log("Final Data:", this.VatnavalViewData);
    }

  });
}

getSundaysOfMonth(month: number, year: number): string[] {

  const result: string[] = [];

  // ✅ First day of month
  let current = new Date(year, month - 1, 1);

  // ✅ Last day of month
  const last = new Date(year, month, 0);

  // ✅ Move to first Sunday
  while (current.getDay() !== 0) {
    current.setDate(current.getDate() + 1);
  }

  // ✅ Collect all Sundays
  while (current <= last) {
    result.push(formatDate(current, 'dd/MM/yyyy', 'en-IN'));
    current.setDate(current.getDate() + 7);
  }

  return result;
}

  getMonthNameMarathi(month: number): string {

  const marathiMonths = [
    'जानेवारी', 'फेब्रुवारी', 'मार्च', 'एप्रिल', 'मे', 'जून',
    'जुलै', 'ऑगस्ट', 'सप्टेंबर', 'ऑक्टोबर', 'नोव्हेंबर', 'डिसेंबर'
  ];

  return marathiMonths[month - 1] || '';
}



// ✅ Sunday Total
getSundayTotal(sunday: string): number {
  return this.VatnavalViewData.reduce((sum, item) => {
    return sum + (Number(item[sunday]) || 0);
  }, 0);
}

// ✅ Total Ank
getTotalAnk(): number {
  return this.VatnavalViewData.reduce((sum, item) => sum + Number(item.total_Ank || 0), 0);
}

// ✅ Vatnaval Total
getVatnavalTotal(): number {
  return this.VatnavalViewData.reduce((sum, item) => sum + Number(item.vatnaval_Total || 0), 0);
}

// ✅ Previous
getPreviousTotal(): number {
  return this.VatnavalViewData.reduce((sum, item) => sum + Number(item.previous_Vatnaval || 0), 0);
}

// ✅ All Vatnaval
getAllVatnavalTotal(): number {
  return this.VatnavalViewData.reduce((sum, item) => sum + Number(item.all_Vatnaval_Amount || 0), 0);
}

 getAccountPaymentAmount(): number {
  return this.VatnavalViewData.reduce((sum, item) => sum + Number(item.payment_Type || 0), 0);
}

// ✅ Remaining
getAllRemainingTotal(): number {
  return this.VatnavalViewData.reduce((sum, item) => sum + Number(item.remaining_Account_Amount || 0), 0);
}

getAllPastDueAmount(): number {
  return this.VatnavalViewData.reduce((sum, item) => sum + Number(item.description || 0), 0);
}



  exportExcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

 show = false

// Old Correct Code
// printPage() {
//   this.show = true;

//   const element = document.getElementById('print-section');

//   if (!element) {
//     console.error("Print section not found!");
//     return;
//   }

//   let htmlContent = element.outerHTML;

//   const formattedStartDate = new Date(this.startDate)
//     .toLocaleDateString('en-GB');

//   const formattedToday = new Date()
//     .toLocaleDateString('en-GB');

//   // ✅ Replace Angular bindings
//   htmlContent = htmlContent
//     .replace(/{{\s*startDate.*?}}/g, formattedStartDate)
//     .replace(/{{\s*today.*?}}/g, formattedToday);

//   // ✅ ⭐ FORCE RIGHT ALIGN FOR DATE BLOCK
//   htmlContent = htmlContent.replace(
//     /दिनांक\s*-\s*\d{2}\/\d{2}\/\d{4}/g,
//     `<div style="text-align:right; width:100%;">दिनांक - ${formattedStartDate}</div>`
//   );

//   const printWindow = window.open('', '_blank');

//   if (!printWindow) {
//     console.error("Failed to open print window.");
//     return;
//   }

//   printWindow.document.open();
//   printWindow.document.write(`
//     <html>
//     <head>
//       <title>Print Report</title>

//       <style>

//         @page { 
//           size: A4 landscape;
//           margin: 5mm;
//         }

//         body {
//           margin: 0;
//           font-family: Arial, sans-serif;
//           font-size: 10px;
//         }

//         /* ✅ HEADER FIX */
//         .row {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         table {
//           width: 100%;
//           border-collapse: collapse;
//         }

//         th {
//           border: 1px solid #000;
//           padding: 4px;
//           text-align: center;
//           font-size: 10px;
//           white-space: normal;
//           word-break: break-word;
//         }

//         td {
//           border: 1px solid #000;
//           padding: 3px;
//           text-align: center;
//           font-size: 10px;
//           white-space: nowrap;
//         }

//         thead th {
//           background: #f2f2f2;
//           font-weight: bold;
//         }

//         @media print {
//           body { zoom: 0.75; }

//           thead { display: table-header-group; }
//           tfoot { display: table-footer-group; }

//           tr { page-break-inside: avoid; }

//           .noPrint { display: none !important; }
//         }

//       </style>

//     </head>

//     <body>

//       ${htmlContent}

//       <script>
//         window.onload = function() {
//           setTimeout(function() {
//             window.print();
//             window.close();
//           }, 300);
//         };
//       <\/script>

//     </body>
//     </html>
//   `);

//   printWindow.document.close();
// }

printPage() {
  this.show = true;

  setTimeout(() => {

    const element = document.getElementById('print-section');

    if (!element) {
      console.error("Print section not found!");
      return;
    }

    let htmlContent = element.innerHTML;

    // ✅ TEMP DOM (for safe manipulation)
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    const tables = tempDiv.querySelectorAll('table');

    tables.forEach(table => {

      let sheracolIndex = -1;

      // ✅ FIND "शेरा" COLUMN INDEX (ONLY ONCE)
      const headerRow = table.querySelector('tr');
      if (headerRow) {
        const headerCells = headerRow.querySelectorAll('th, td');
        headerCells.forEach((cell, index) => {
          if (cell.textContent?.trim() === 'शेरा') {
            sheracolIndex = index;
          }
        });
      }

      // ✅ REMOVE "शेरा" COLUMN FROM ALL ROWS
      if (sheracolIndex !== -1) {
        table.querySelectorAll('tr').forEach(row => {
          const cells = row.querySelectorAll('th, td');
          if (cells[sheracolIndex]) {
            cells[sheracolIndex].remove();
          }
        });
      }

      // ✅ ALIGN: STRING = LEFT, AMOUNT/NUMBER = RIGHT
      table.querySelectorAll('tbody tr').forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, colIndex) => {
          const rawText = cell.textContent?.trim() || '';

          // ✅ Serial number column → center
          if (colIndex === 0) {
            (cell as HTMLElement).style.textAlign = 'center';
            return;
          }

          // ✅ Name & Place columns → left align (col 1 and 2)
          if (colIndex === 1 || colIndex === 2) {
            (cell as HTMLElement).style.textAlign = 'left';
            (cell as HTMLElement).style.paddingLeft = '5px';
            return;
          }

          // ✅ Date column (अकाऊंट दिनांक) → center
          // Detect dd-MM-yyyy format
          const isDate = /^\d{2}-\d{2}-\d{4}$/.test(rawText);
          if (isDate) {
            (cell as HTMLElement).style.textAlign = 'center';
            return;
          }

          // ✅ Number/Amount → right align
          const isNumeric = rawText === '' || rawText === '0' || (!isNaN(Number(rawText)) && rawText !== '');
          if (isNumeric) {
            (cell as HTMLElement).style.textAlign = 'right';
            (cell as HTMLElement).style.paddingRight = '5px';
          } else {
            // ✅ Any other text → left align
            (cell as HTMLElement).style.textAlign = 'left';
            (cell as HTMLElement).style.paddingLeft = '5px';
          }
        });
      });

      // ✅ FOOTER ROW ALIGNMENT
      table.querySelectorAll('tfoot tr').forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, colIndex) => {
          const rawText = cell.textContent?.trim() || '';

          if (colIndex === 0) {
            (cell as HTMLElement).style.textAlign = 'center';
            return;
          }

          const isNumeric = rawText === '' || rawText === '0' || (!isNaN(Number(rawText)) && rawText !== '');
          if (isNumeric) {
            (cell as HTMLElement).style.textAlign = 'right';
            (cell as HTMLElement).style.paddingRight = '5px';
          } else {
            (cell as HTMLElement).style.textAlign = 'left';
            (cell as HTMLElement).style.paddingLeft = '5px';
          }
        });
      });

    });

    // ✅ REMOVE ROW "हस्ते वाटणावळ - एप्रिल 2026"
    tempDiv.querySelectorAll('tr').forEach(row => {
      if (row.textContent?.includes('हस्ते वाटणावळ')) {
        row.remove();
      }
    });

    // ✅ CLONE FOOTER INTO HEADER (REPEAT ON EVERY PAGE)
    let updatedHTML = tempDiv.innerHTML.replace(
      /<tfoot>([\s\S]*?)<\/tfoot>/gi,
      (match, footerContent) => {
        return `
          <thead class="repeat-footer">
            ${footerContent}
          </thead>
          ${match}
        `;
      }
    );

    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      console.error("Failed to open print window.");
      return;
    }

    printWindow.document.open();
    printWindow.document.write(`
      <html>
      <head>
        <title>Print Report</title>

        <style>

          @page { 
            size: A4 landscape;
            margin: 5mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 12px;
          }

          .row {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }

          th {
            border: 1px solid #000;
            padding: 4px;
            text-align: center;
            font-size: 12px;
            white-space: normal;
            word-break: break-word;
          }

          td {
            border: 1px solid #000;
            padding: 3px;
            font-size: 12px;
            white-space: nowrap;
          }

          thead th {
            background: #f2f2f2;
            font-weight: bold;
          }

          thead { display: table-header-group; }
          tfoot { display: table-row-group; }

          @media print {
            body { zoom: 0.75; }
            tr { page-break-inside: avoid; }
            .noPrint { display: none !important; }
          }

        </style>

      </head>

      <body>

        ${updatedHTML}

        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.close();
            }, 300);
          };
        <\/script>

      </body>
      </html>
    `);

    printWindow.document.close();

    this.show = false;

  }, 300);
}

}
